import React, { useContext, useState } from "react";
import { MachineContext } from "../../contexts/MachineContext";
import CardComponent from "../../components/CardComponent";
import { gridSizesClassName } from "../../utils/gridSizes";
import { datetimeToPrettyString } from "../../utils/data";
import { getMachineParamsStatusValue } from "../../utils/miplus";
import { LocalesContext } from "../../contexts/LocalesContext";
import { convertValue, getUnit } from "../../utils/unitsConverter";

export default function RealtimeComponent(props) {
  const { machineName, machineParams, machineRtStatus } =
    useContext(MachineContext);
  const { t } = useContext(LocalesContext);
  const isImperial = props.unitsSystem === 'imperial';

  let status = machineRtStatus;
  let classNameStatus = "";
  let labelDataStatus =
    machineParams && machineParams.statLastUsage
      ? `Last usage: ${datetimeToPrettyString(
          new Date(machineParams.statLastUsage)
        )}`
      : "Not used yet";
  let labelAction = "";
  let functionAction = null;
  let labelClass = "";

  if (status == "connected") {
    classNameStatus = "is-connected";
    labelClass="c-table__status--connected";
    if (machineParams && machineParams.diagnostic) {
      const area = convertValue(machineParams.diagnostic.superficieTotale, 'area', isImperial);
      const unit = getUnit('area', isImperial);
      labelDataStatus = `${labelDataStatus} - Total worked area: ${area} ${unit}`;
    }
  } else if (status == "disconnected") {
    classNameStatus = "is-disconnected";
    labelDataStatus = t("application.connestion_statuses.disconnected");
    labelClass="c-table__status--disconnected";
  } else if (status == "working") {
    classNameStatus = "is-working";
    labelClass="c-table__status--working";
    if (machineParams && machineParams.diagnostic) {
      const area = convertValue(machineParams.diagnostic.superficieTotale, 'area', isImperial);
      const unit = getUnit('area', isImperial);
      labelDataStatus = `${labelDataStatus} - Total worked area: ${area} ${unit}`;
    }
  }

  return (
    <>
      <div className="r-realtime__container row">
        <div className={`r-realtime__status ${classNameStatus}`}></div>
        <div className="r-realtime__data">
          <div className="r-realtime__data-name">{machineName}</div>
          <div className={"c-table__status " + labelClass }>{labelDataStatus}</div>
        </div>
        {labelAction && functionAction && (
          <button
            className="c-button"
            onClick={functionAction}
            disabled={!ctaEnabled}
          >
            {labelAction}
          </button>
        )}
      </div>
    </>
  );
}